import { render, staticRenderFns } from "./editor2.vue?vue&type=template&id=15dad698&scoped=true&"
import script from "./editor2.vue?vue&type=script&lang=js&"
export * from "./editor2.vue?vue&type=script&lang=js&"
import style0 from "./editor2.vue?vue&type=style&index=0&id=15dad698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dad698",
  null
  
)

export default component.exports